import { useTranslation } from "react-i18next";
import { DropdownItem, DropdownMenu } from "reactstrap";
import Auth from "services/auth";
import "assets/styles/components/navbar.scss";
import "assets/styles/components/dropdown.scss";
import { COINNIK_MARKET_APP_URL } from "configs/constants";

function AccountUser(props: any) {
  const { t } = useTranslation();
  const logout = () => {
    const AuthClass = new Auth();
    AuthClass.logout();
  };

  const [mail] = props.email.split("@");

  return (
    <DropdownMenu className="py-3 px-1 w-100   mt-0">
      <DropdownItem>
        <div className="d-flex align-items-center  ">
          <i className="icon-account-circle " />
          <span className="mx-1 overflow-hidden style-ltr">{mail}</span>
        </div>
      </DropdownItem>
      <DropdownItem divider className="mx-3 " />
      <DropdownItem
        href={`${COINNIK_MARKET_APP_URL}dashboard`}
        className="pt-2 pb-2"
      >
        <div className="d-flex align-items-center  ">
          <i className="icon-dashboard " />
          <span className="px-2">{t("Login to the dashboard")}</span>
        </div>
      </DropdownItem>
      <DropdownItem
        href={`${COINNIK_MARKET_APP_URL}settings/identity-auth`}
        className="align-items-right pb-2 pt-2"
      >
        <div className="d-flex align-items-center ">
          <i className="icon-setting " />
          <span className="px-2"> {t("Setting")}</span>
        </div>
      </DropdownItem>
      <DropdownItem divider className="mx-3" />
      <DropdownItem onClick={logout}>
        <div className="d-flex align-items-center ">
          <i className="icon-logout " />
          <span className="px-2"> {t("Logout")}</span>
        </div>
      </DropdownItem>
    </DropdownMenu>
  );
}
export default AccountUser;
